import call, { json } from './call';

// Card endpoints. addCardFact resolves with the card's updated facts list.
export const addCardFact = (token, cardId, fact) => call(`/api/cards/${cardId}/facts`, token, json('POST', fact));
